import {
  Alert,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { UserContext } from "../../../../context/UserContext";
import { axiosInstance } from "../../../../utils/networking";
import { Editor } from "@tinymce/tinymce-react";
import "tinymce/tinymce";
import "tinymce/themes/silver";
import "tinymce/icons/default";
import "tinymce/models/dom";
import "tinymce/plugins/lists";
import "tinymce/plugins/link";
import "tinymce/plugins/image";
import "tinymce/plugins/table";
import "tinymce/plugins/help";
import {
  beforeTemplate,
  afterTemplate,
} from "../../../common/EmailBodies/DirectEmailEmptyBody";
import { ContentStepProps } from "../broadcastTypes";

const CustomEmailContent = ({ contentData, setContentData }: ContentStepProps) => {
  const { user } = useContext(UserContext);
  const editorRef = useRef<any>(null);
  const [templates, setTemplates] = useState<any[]>([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState<string>("");

  const initialValueRef = useRef<string>(
    contentData.htmlContent || beforeTemplate(null) + "<p>Type your message here...</p>" + afterTemplate(user, null)
  );

  useEffect(() => {
    axiosInstance.get("/email/template").then((res) => {
      setTemplates(res.data.email_tamplates || []);
    });
  }, []);

  const handleTemplateChange = (templateId: string) => {
    setSelectedTemplateId(templateId);
    const template = templates.find((t: any) => t._id === templateId);
    if (!template) return;
    const fullHtml = beforeTemplate(null) + template.htmlContent + afterTemplate(user, null);
    setContentData({ ...contentData, subject: template.subject || contentData.subject, htmlContent: fullHtml });
    if (editorRef.current) {
      editorRef.current.setContent(fullHtml);
    }
  };

  const handleEditorChange = (value: string) => {
    setContentData({ ...contentData, htmlContent: value });
  };

  const handleSubjectChange = (subject: string) => {
    setContentData({ ...contentData, subject });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
      <Stack direction="row" spacing={2} alignItems="center">
        <FormControl sx={{ minWidth: 220 }}>
          <InputLabel>Load from Template</InputLabel>
          <Select
            value={selectedTemplateId}
            label="Load from Template"
            onChange={(e) => handleTemplateChange(e.target.value)}
          >
            <MenuItem value="">
              <em>None (start fresh)</em>
            </MenuItem>
            {templates.map((t: any) => (
              <MenuItem key={t._id} value={t._id}>
                {t.template_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Email Subject"
          fullWidth
          value={contentData.subject}
          onChange={(e) => handleSubjectChange(e.target.value)}
          placeholder="Subject line..."
        />
      </Stack>

      <Box
        sx={{
          border: "1px solid #c4c4c4",
          borderRadius: "0 0 10px 10px",
          height: 500,
        }}
      >
        <Editor
          onInit={(_evt: any, editor: any) => {
            editorRef.current = editor;
          }}
          initialValue={initialValueRef.current}
          onEditorChange={handleEditorChange}
          init={{
            licenseKey: "gpl",
            skin_url: "/skins/ui/oxide",
            content_css: "/skins/content/default/content.css",
            height: 500,
            menubar: false,
            toolbar:
              "undo redo | formatselect | " +
              "bold italic backcolor | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | " +
              "removeformat | help",
            content_style:
              "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          }}
        />
      </Box>

      <Alert severity="info">
        The unsubscribe link is added automatically.
      </Alert>
    </Box>
  );
};

export default CustomEmailContent;
